var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgInfoIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: "100%",
    strokeMiterlimit: 10,
    style: {
      fillRule: "nonzero",
      clipRule: "evenodd",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    },
    viewBox: "0 0 67 59",
    width: "100%",
    xmlSpace: "preserve",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsVectornator: "http://vectornator.io",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Untitled",
    vectornatorLayerName: "Untitled"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.2233 29.5C12.2233 17.7492 21.7492 8.22331 33.5 8.22331C45.2508 8.22331 54.7767 17.7492 54.7767 29.5C54.7767 41.2508 45.2508 50.7767 33.5 50.7767C21.7492 50.7767 12.2233 41.2508 12.2233 29.5Z",
    fill: "#ffffff",
    fillRule: "nonzero",
    opacity: 1,
    stroke: "#797876",
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.7865 15.9332L35.1817 15.9332L35.1817 19.3285L31.7865 19.3285L31.7865 15.9332Z",
    fill: "#797876",
    fillRule: "nonzero",
    opacity: 1,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.8994 22.9475L35.244 22.9475L35.244 42.0344L31.8994 42.0344L31.8994 22.9475Z",
    fill: "#797876",
    fillRule: "nonzero",
    opacity: 1,
    stroke: "none"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfoIcon);
export default __webpack_public_path__ + "static/media/info_icon.fbc0b6e07ee15a699a122935ff29cb6d.svg";
export { ForwardRef as ReactComponent };